import React, { useMemo } from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import { Translateable } from 'components/Translateable'
import PropTypes from 'prop-types'
import { Text } from './components'

const Container = styled.div`
	height: 100%;
	width: 100%;
	overflow: hidden;
	padding: 56px 16px 36px 8px;
	${breakpoint(`tablet`)`
		padding: 80px 48px 36px 24px;
	`}
	${breakpoint(`tablet`)`
		padding: 116px 48px 36px 32px;
`}
`

const DesktopWrapper = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: flex-start;
	overflow: auto;
	padding-right: 8px;

	&::-webkit-scrollbar {
		border-radius: 4px;
		background-color: rgba(0, 0, 0, 1);
	}
	&::-webkit-scrollbar-thumb {
		border-radius: 6px;
		background-color: white;
		border: 2px solid rgba(0, 0, 0, 1);
	}
`

const HTMLify = arrStr =>
	arrStr.map((text, i) => (
		<span key={text}>
			{text}
			{i < arrStr.length - 1 && (
				<>
					<br />
					<br />
				</>
			)}
		</span>
	))

const englishText = [
	`I'm an NYC-based full-stack developer currently seeking a junior/entry software development role in the greater
	New York area.`,

	`I have experience with a variety of programming languages as well as 
	several front-end and back-end frameworks but at the moment tend towards a full JavaScript stack, 
	specifically React/Express/MongoDB.`,

	`As a Full Stack Developer with an interest in developing scalable applications with emerging technologies 
	and writing efficient business logic, I have about 1+ years of enterprise software development experience 
	at Pace University, where I had the opportunity to work with educational sectors. I am curious about the 
	how’s and the why's of any product which could be a software product or actual hardware. 
	The drive for solving problems with refactoring solutions every day is what I enjoy about software development 
	in general. While also incorporating the knowledge gained by various sources to build a better product which 
	aids the user experience.`,

	`I am currently pursuing my Master’s in Computer Science from Pace University and will be graduating 
	in December 2020 and looking for internship/Full-time opportunities where I could further hone my skill 
	sets by contributing to challenging projects for the organization I work for.`,

	`I'm highly adaptable and never shy away from a challenge or unfamiliar technology. 
	Take a look a around this site to learn more. Think I could be your next great hire? 
	Feel free to contact me for this or anything at all.`

	
]

const spanishText = [
	`Soy un desarrollador de pila completa con sede en Nueva York que actualmente busca un rol de desarrollo de software junior / de entrada en el gran
	Zona de Nueva York.`,

	`Tengo experiencia con una variedad de lenguajes de programación, así como
	varios marcos front-end y back-end, pero en este momento tienden a una pila completa de JavaScript,
	específicamente React / Express / MongoDB.`,

	`Como desarrollador Full Stack con interés en desarrollar aplicaciones escalables con tecnologías emergentes
	y escribiendo una lógica comercial eficiente, tengo aproximadamente 1 año de experiencia en desarrollo de software empresarial
	en la Universidad Pace, donde tuve la oportunidad de trabajar con sectores educativos. Tengo curiosidad sobre el
	cómo y por qué de cualquier producto que podría ser un producto de software o hardware real.
	El impulso para resolver problemas con las soluciones de refactorización todos los días es lo que disfruto del desarrollo de software
	en general. Al mismo tiempo que incorpora el conocimiento adquirido por varias fuentes para construir un mejor producto que
	Ayuda a la experiencia del usuario.`,

	`Actualmente estoy cursando mi Maestría en Ciencias de la Computación de la Universidad Pace y me graduaré
	en diciembre de 2020 y en busca de pasantías / oportunidades de tiempo completo donde podría perfeccionar aún más mi habilidad
	establece contribuyendo a proyectos desafiantes para la organización para la que trabajo.`,

	`Soy altamente adaptable y nunca evito un desafío o una tecnología desconocida.
	Eche un vistazo a este sitio para obtener más información. ¿Crees que podría ser tu próxima gran contratación?
	No dude en ponerse en contacto conmigo para esto o cualquier cosa.`
]

const AboutMe = props => {
	const { fontColor } = props

	const en = useMemo(() => HTMLify(englishText), [])
	const es = useMemo(() => HTMLify(spanishText), [])
	return (
		<Container>
			<DesktopWrapper>
				<Text fontColor={fontColor}>
					<Translateable en={en} es={es} />
				</Text>
			</DesktopWrapper>
		</Container>
	)
}

AboutMe.propTypes = {
	fontColor: PropTypes.string
}

export default AboutMe
